<template>
  <div>
    <div @click="getFileForUpload">
      <img v-if='data.thumbnailUrl' class='rounded-circle avatar-md upload' :src='`${data.thumbnailUrl}`' />
      <div v-else class='avatar-sm mb-4'>
        <span class='avatar-title rounded-circle bg-soft-primary text-primary font-size-16 upload'>
          {{ data.initials }}
        </span>
      </div>
      <input type="file"
         ref="file"
         name="image"
         @change="uploadImage($event.target.files[0])"
         style="display:none"
         accept="image/*">
      <p class="font-size-11 text-white"> {{ data.thumbnailUrl ? 'Change' : 'Add' }} Photo</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'upload-profile-photo',
  props: ['data', 'type', 'userId'],
  methods: {
    getFileForUpload () {
      this.$refs.file.click()
    },
    uploadImage (file) {
      const self = this
      const formData = new FormData()
      formData.append('userId', this.userId)
      formData.append('file', file)
      this.$store.dispatch('uploadImage', formData).then(function (response) {
        if (response.data.success) {
          const imageData = {
            imageUrl: response.data.imageUrl,
            type: self.type,
            userId: self.userId
          }
          self.$store.dispatch('updateImageUrl', imageData)
        }
        // self.isProcessing = false
      }).catch(() => {
      })
    }
  },
  mounted () {

  }
}
</script>
<style>
  .upload:hover {
    border: 1px dashed #FFF;
    cursor: pointer;
    transition: all 250ms ease 0s;
  }
  #client-modal .avatar-sm{
    margin:0 auto;
  }
</style>
